import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import CheckPicker from "rsuite/CheckPicker";
import "rsuite/CheckPicker/styles/index.css";
import SelectPicker from "rsuite/SelectPicker";

const RsuiteChecker = ({
  data,
  onChange,
  field_name,
  async,
  feedbackAsyncCall,
  loading,
  select,
  val,
  searchable,
}) => {
  console.log(data, 43535454234);
  const [search, setSearch] = useState("");
  const setSeach = (evt) => {
    setSearch(evt);
    if (!evt) {
      feedbackAsyncCall(evt);
    }
  };

  useEffect(() => {
    let timeout;
    timeout = setTimeout(() => {
      if (search) {
        feedbackAsyncCall(search);
      }
    }, [500]);
    return () => {
      clearTimeout(timeout);
    };
  }, [search]);
  if (select) {
    return (
      <div>
        <SelectPicker
          style={{ width: "100%", zIndex: 1050 }}
          data={data.map((item) => {
            return {
              label:
                item.value.length > 20
                  ? item.value.slice(0, 15) + "..."
                  : item.value,
              value: item.id,
            };
          })}
          value={val}
          searchable={searchable || false}
          onChange={(evt) => onChange(evt, field_name)}
        />
      </div>
    );
  }
  if (async) {
    return (
      <div>
        <CheckPicker
          onOpen={feedbackAsyncCall}
          data={data}
          value={val}
          onSearch={setSeach}
          onChange={(evt) => onChange(evt, field_name)}
          style={{ width: "100%", zIndex: 1050 }}
          loading={loading}
        />
      </div>
    );
  }
  if (field_name === "feature") {
    return (
      <div>
        <CheckPicker
          style={{ width: "100%", zIndex: 1050 }}
          data={data.map((item) => {
            return { label: item.value.slice(0, 30), value: item.id };
          })}
          value={val}
          onChange={(evt) => onChange(evt, field_name)}
        />
      </div>
    );
  }
  return (
    <div>
      <CheckPicker
        style={{ width: "100%", zIndex: 1050 }}
        data={data.map((item) => {
          return { label: item.value, value: item.id };
        })}
        value={val}
        onChange={(evt) => onChange(evt, field_name)}
      />
    </div>
  );
};

export default RsuiteChecker;



// WEBPACK FOOTER //
// ./src/components/RsuiteChecker.js